import { render } from "./App.vue?vue&type=template&id=ebdfbf26"
const script = {}

import "./App.vue?vue&type=style&index=0&id=ebdfbf26&lang=scss"
script.render = render

export default script